import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;
